import { TbBolt, TbClock, TbShieldCheck, TbShieldExclamation } from "react-icons/tb";
import FormatDateTime from "../Functions/FormatDate";
import { useLanguage } from "../Translations/LenguageContext";
import VerifyDomainModal from "./PropSetup/VerifyDomainModal";
import { MdQuestionMark } from "react-icons/md";
import InfoInstallationModal from "./InfoInstallationModal";

const PropOverview = ({
    data,
    fetchData,
    handleVerifyDomain,
    verifyContent,
    loadingVerify,
    setLoadingVerify,
    errorMessageVerify,
    setErrorMessageVerify,
    showVerifyDomain,
    setShowVerifyDomain,
    setOpenSettingsModal,
    openInfoInstallationModal,
    setOpenInfoInstallationModal
}) => {
    const { t } = useLanguage()

    return (
        <div className="open_frame_body">
            <div className="open_property_cont">
                <div className="open_property_header">
                    {/* <div className="open_property_header_icon">
                        <img
                            src={`https://www.google.com/s2/favicons?domain=${encodeURIComponent(data?.base_url || "")}&sz=64`}
                            alt=""
                            onError={(e) => {
                                e.currentTarget.style.display = "none";
                            }}
                        />
                    </div> */}
                    <div className="open_property_header_content">
                        <p className="open_property_header_content_title fade-in">
                            {data?.domain}
                        </p>
                        <p className="open_property_header_content_subtitle fade-in">{data?.base_url}</p>
                    </div>
                </div>
                <div className="open_property_body">
                    <div className="open_property_body_row">
                        <div className="open_property_body_row_cell">
                            <p className="open_property_body_row_cell_title fade-in">
                                <span>
                                    <i>
                                        {data?.tag_status === "DETECTED" ? (
                                            <TbShieldCheck />
                                        ) : (
                                            <TbShieldExclamation />
                                        )}
                                    </i>
                                    {t.properties.connection_title}
                                </span>
                                <button className="tag_header_btn" onClick={() => setOpenInfoInstallationModal(true)}><MdQuestionMark /></button>
                            </p>

                            {data?.tag_status === "DETECTED" ? (
                                <>
                                    <p className="open_property_body_row_cell_status status_ok fade-in">
                                        {t.properties.connected_status}
                                    </p>
                                    <p className="open_property_body_row_cell_description fade-in">
                                        {t.properties.connected_status_desc}
                                    </p>
                                </>
                            ) : data?.tag_status === "NOT_INSTALLED" ? (
                                <>
                                    <p className="open_property_body_row_cell_status status_warn fade-in">
                                        {t.properties.not_installed_status}
                                    </p>
                                    <p className="open_property_body_row_cell_description fade-in">
                                        {t.properties.not_installed_status_desc}
                                    </p>
                                </>
                            ) : (
                                <>
                                    <p className="open_property_body_row_cell_status status_err fade-in">
                                        {t.properties.connection_error_status}
                                    </p>
                                    <p className="open_property_body_row_cell_description fade-in">
                                        {t.properties.connection_error_status_desc}
                                    </p>
                                </>
                            )}
                        </div>

                        <div className="open_property_body_row_cell">
                            <p className="open_property_body_row_cell_title fade-in">
                                <span>
                                    <i>
                                        <TbClock />
                                    </i>
                                    {t.properties.last_activity_title}
                                </span>
                            </p>

                            <p className="open_property_body_row_cell_status fade-in">
                                {FormatDateTime(data?.last_tag_seen_at)?.split(" - ")[0] || "—"}
                            </p>

                            <p className="open_property_body_row_cell_description fade-in">
                                {FormatDateTime(data?.last_tag_seen_at)?.split(" - ")[1]
                                    ? `${FormatDateTime(data?.last_tag_seen_at).split(" - ")[1]}`
                                    : t.properties.last_activity_time_desc} UTC
                            </p>
                        </div>
                    </div>
                    <div className="open_property_body_row">
                        <div className="open_property_body_row_cell">
                            <p className="open_property_body_row_cell_title fade-in">
                                <span>
                                    <i>
                                        <TbBolt />
                                    </i>
                                    {t.properties.deployment_title}
                                </span>
                                <button className="tag_header_btn" onClick={() => setOpenSettingsModal(true)}><MdQuestionMark /></button>
                            </p>

                            {data?.deployment_enabled ? (
                                <>
                                    <p className="open_property_body_row_cell_status status_ok fade-in">
                                        {t.properties.deployment_enabled_status}
                                    </p>
                                    <p className="open_property_body_row_cell_description fade-in">
                                        {t.properties.deployment_enabled_status_desc}
                                    </p>
                                </>
                            ) : (
                                <>
                                    <p className="open_property_body_row_cell_status status_warn fade-in">
                                        {t.properties.deployment_disabled_status}
                                    </p>
                                    <p className="open_property_body_row_cell_description fade-in">
                                        {t.properties.deployment_disabled_status_desc}
                                    </p>
                                </>
                            )}
                        </div>

                        <div className="open_property_body_row_cell">
                            <p className="open_property_body_row_cell_title fade-in">
                                <span>
                                    <i>
                                        {data?.verification_status === "VERIFIED" ? (
                                            <TbShieldCheck />
                                        ) : (
                                            <TbShieldExclamation />
                                        )}
                                    </i>
                                    {t.properties.verification_title}
                                </span>
                                <button className="tag_header_btn" onClick={() => setShowVerifyDomain(true)}><MdQuestionMark /></button>
                            </p>

                            {data?.verification_status === "VERIFIED" ? (
                                <>
                                    <p className="open_property_body_row_cell_status status_ok fade-in">
                                        {t.properties.verified_status}
                                    </p>
                                    <p className="open_property_body_row_cell_description fade-in">
                                        {t.properties.verified_status_desc}{" "}
                                        {FormatDateTime(data?.verified_at)}
                                    </p>
                                </>
                            ) : data?.verification_status === "FAILED" ? (
                                <>
                                    <p className="open_property_body_row_cell_status status_err fade-in">
                                        {t.properties.verification_failed_status}
                                    </p>
                                    <p className="open_property_body_row_cell_description fade-in">
                                        {t.properties.verification_failed_status_desc}
                                    </p>
                                </>
                            ) : (
                                <>
                                    <p className="open_property_body_row_cell_status status_warn fade-in">
                                        {t.properties.pending_verification_status}
                                    </p>
                                    <p className="open_property_body_row_cell_description fade-in">
                                        {t.properties.pending_verification_status_desc}
                                    </p>
                                </>
                            )}
                        </div>
                    </div>
                </div>

                {(data?.verification_status !== "VERIFIED" || !data?.deployment_enabled) && (
                    <div className="open_property_footer">
                        {data?.verification_status !== "VERIFIED" && (
                            <div className="open_property_footer_item">
                                <p className="open_property_footer_item_p fade-in">
                                    {t.properties.verify_domain_desc}
                                </p>
                                <button
                                    className="open_property_footer_item_btn fade-in"
                                    onClick={() => setShowVerifyDomain(true)}
                                >
                                    {t.properties.verify_domain_btn}
                                </button>
                            </div>
                        )}

                        {!data?.deployment_enabled && (
                            <div className="open_property_footer_item">
                                <p className="open_property_footer_item_p fade-in">
                                    {t.properties.enable_deployment_desc}
                                </p>
                                <button className="open_property_footer_item_btn fade-in" onClick={() => setOpenSettingsModal(true)}>
                                    {t.properties.enable_deployment_btn}
                                </button>
                            </div>
                        )}
                    </div>
                )}
            </div>

            <VerifyDomainModal
                show={showVerifyDomain}
                handleClose={() => setShowVerifyDomain(false)}
                data={data}
                fetchData={fetchData}
                handleVerifyDomain={handleVerifyDomain}
                verifyContent={verifyContent}
                loadingVerify={loadingVerify}
                setLoadingVerify={setLoadingVerify}
                errorMessageVerify={errorMessageVerify}
                setErrorMessageVerify={setErrorMessageVerify}
            />

            <InfoInstallationModal
                show={openInfoInstallationModal}
                handleClose={() => setOpenInfoInstallationModal(false)}
                site_id={data?.site_id}
            />
        </div>
    )
}

export default PropOverview